import Typography from "@mui/material/Typography";

export const Loading = () => {
    return <Typography variant="h6">Authentication in progress...</Typography>
}